import { FC } from 'react';
import Countdown, { CountdownRenderProps } from 'react-countdown';
import { Box, Text } from '@components/design-system';

export interface ICountdownSimple {
  auctionEnd: number;
}

export const CountdownSimple: FC<ICountdownSimple> = ({ auctionEnd }) => {
  const renderer = (props: CountdownRenderProps) => {
    const { formatted, completed } = props;
    const { days, hours, minutes, seconds } = formatted;

    if (completed) {
      // TODO: decide what to do when bidding finish
      return (
        <Text unset css={{ color: '$secondaryFill' }}>
          This auction has ended
        </Text>
      );
    }

    return (
      <Text unset css={{ color: '$secondaryFill', fontSize: 14, fontFamily: '$mono' }}>
        {days !== '00' && `${days}d`} {hours}h {minutes}m {seconds}s
      </Text>
    );
  };

  return (
    <Box css={{ display: 'flex', flexDirection: 'column' }}>
      <Countdown
        date={auctionEnd}
        renderer={renderer}
        onComplete={() => {
          // TODO: bidding ended. Do something
        }}
      />
    </Box>
  );
};
